import api from '../../../../api'

export const FETCH_TRIPS_MADE_PENDING = 'FETCH_TRIPS_MADE_PENDING'
export const FETCH_TRIPS_MADE_FULFILLED = 'FETCH_TRIPS_MADE_FULFILLED'
export const FETCH_TRIPS_MADE_REJECTED = 'FETCH_TRIPS_MADE_REJECTED'

export const DELETE_TRIPS_MADE_PENDING = 'DELETE_TRIPS_MADE_PENDING'
export const DELETE_TRIPS_MADE_FULFILLED = 'DELETE_TRIPS_MADE_FULFILLED'
export const DELETE_TRIPS_MADE_REJECTED = 'DELETE_TRIPS_MADE_REJECTED'

export const CHANGE_TRIPS_MADE = 'CHANGE_TRIPS_MADE'

export function changeTripsMade(name, value) {
  return dispatch => {
    dispatch({ type: CHANGE_TRIPS_MADE, payload: { name, value } })
  }
}

export function findAllTripsMades(veiculo = 0, startPeriod = '', stopPeriod = '') {
  
  return dispatch => new Promise((resolve, reject) => {

    dispatch({ type: FETCH_TRIPS_MADE_PENDING });

    api({
      method: 'post',
      data: {
        query: `
                query findAllTripsMades {
                  viagensRealizadasPorVeiculo (
                    veiculo: ${veiculo} 
                    startPeriod: "${startPeriod}",
                    stopPeriod: "${stopPeriod}"
                  ) {
                    placa
                    motorista
                    dataHoraInicial
                    dataHoraFinal
                    odometroInicial
                    odometroFinal
                    localizacaoInicial
                    localizacaoFinal
                    tempoViagem
                    tempoParado
                    distancia
                    latitudeInicial
                    longitudeInicial
                    latitudeFinal
                    longitudeFinal
                  }
                }
                `
      }
    }).then((result) => {
      const { errors, data } = result.data
      if (errors) {
        dispatch({ type: FETCH_TRIPS_MADE_REJECTED, payload: errors });
        reject(errors);
      } else {
        const { viagensRealizadasPorVeiculo } = data
        dispatch({ type: FETCH_TRIPS_MADE_FULFILLED, payload: viagensRealizadasPorVeiculo });
        resolve(data);
      }
    }).catch((error) => {
      dispatch({ type: FETCH_TRIPS_MADE_REJECTED, error });
      reject(error);
    });

  });

}
